<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    window.getPageName = this.getPageName;
  },
  methods: {
    /**
     * 获取当前页面路由的name
     * 安卓那边需要判断页面
     */
    getPageName() {
      return this.$route.name;
    },
  },
};
</script>
